import { SCREEN } from "../useConsensusActivity";

const TIME_DELAY = 750;

const dataTrackDefault = {
  event_type: null,
  data: {
    screen: null,
  },
}

export const screenChallengeHandler = ({
  surveyTimeoutRef,
  isSessionCompleteRef = { current: false },
  setIsShowTransitionView,
  event = dataTrackDefault,
}) => {
  const { event_type, data } = event;
  const { screen } = data ?? {};
  if (event_type === SCREEN.CHANGE) {
    if (screen === SCREEN.COLOR) {
      if (surveyTimeoutRef.current) {
        clearTimeout(surveyTimeoutRef.current);
      }
      setIsShowTransitionView(true);
    }

    // After the session completes, the transition view holds the session
    // survey. The orchestrator can still broadcast a challenge screen queued
    // behind a blocking speech, so ignore it whether it arrives after complete
    // or arrived just before and its timer fires after.
    if (screen === SCREEN.CHALLENGE && !isSessionCompleteRef.current) {
      setTimeout(() => {
        if (isSessionCompleteRef.current) return;
        setIsShowTransitionView(false);
      }, TIME_DELAY);
    }
  }
};

